<template>
  <div>
    <div class="  mb-4">
      <p class="font-semibold text-sm mb-2">Campaign NAME</p>
      <b-input placeholder="Enter Campaign Order..." />
    </div>
    <div class="  mb-4">
      <p class="font-semibold text-sm mb-2">Spending</p>
      <b-input placeholder="Enter Spending..." />
    </div>
    <div class="  mb-4">
      <p class="font-semibold text-sm mb-2">Start Date</p>
      <base-input>
        <flat-picker
          placeholder="Select Start Date"
          slot-scope="{ focus, blur }"
          @on-open="focus"
          @on-close="blur"
          :config="{ allowInput: true }"
          class="form-control datepicker"
        >
        </flat-picker>
      </base-input>
    </div>
    <div class="  mb-4">
      <p class="font-semibold text-sm mb-2">End Date</p>
      <base-input>
        <flat-picker
          placeholder="Select End Date"
          slot-scope="{ focus, blur }"
          @on-open="focus"
          @on-close="blur"
          :config="{ allowInput: true }"
          class="form-control datepicker"
        >
        </flat-picker>
      </base-input>
    </div>
  </div>
</template>
<script>
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
export default {
  data() {
    return {};
  },
  components: {
    flatPicker
  }
};
</script>
